import React, { useState } from 'react';
import { Container, Form, Button, Card, Nav } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import './Reports.css';

const CheckReport = () => {
  const [formData, setFormData] = useState({
    title: '',
    description: '',
    date: '',
    status: 'pending',
  });
  const [attachment, setAttachment] = useState(null);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleFileChange = (e) => {
    setAttachment(e.target.files[0]);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Reset form
    setFormData({
      title: '',
      description: '',
      date: '',
      status: 'pending',
    });
    setAttachment(null);
    const fileInput = document.getElementById('attachment');
    if (fileInput) fileInput.value = '';

    toast.success('Cheque report submitted successfully!');
  };

  return (
    <Container fluid className="reports-container">
      <div className="page-header">
        <h2 className="page-title">✅ Reports Management</h2>
        <p className="page-subtitle">Create and manage your check reports</p>
      </div>

      <Nav className="report-tabs">
        <Nav.Item>
          <Nav.Link as={Link} to="/reports/daily">
            📊 Daily Report
          </Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link as={Link} to="/reports/check" active>
            ✅ Check Report
          </Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link as={Link} to="/reports/festive">
            🎉 Festive Report
          </Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link as={Link} to="/reports/offer">
            🎁 Offer Report
          </Nav.Link>
        </Nav.Item>
      </Nav>

      <Card className="report-form-card">
        <Card.Header className="report-form-header">
          <h4 className="report-form-title">
            <span>✅</span>
            <span>Check Reporting Form</span>
          </h4>
        </Card.Header>
        <Card.Body className="report-form-body">
          <div className="form-instructions">
            <div className="instructions-title">
              <span>💡</span>
              <span>Instructions</span>
            </div>
            <ul className="instructions-list">
              <li>Fill in all required fields marked with an asterisk (*)</li>
              <li>Provide a clear title for your check report</li>
              <li>Include detailed verification and check details</li>
              <li>Attach supporting documentation if available</li>
            </ul>
          </div>

          <Form onSubmit={handleSubmit}>
            <Form.Group className="form-group-modern">
              <Form.Label className="form-label-modern">
                <span className="label-icon">📋</span>
                <span>Check Title *</span>
              </Form.Label>
              <div className="form-input-wrapper">
                <Form.Control
                  type="text"
                  name="title"
                  value={formData.title}
                  onChange={handleInputChange}
                  placeholder="Enter check report title..."
                  required
                />
              </div>
            </Form.Group>

            <Form.Group className="form-group-modern">
              <Form.Label className="form-label-modern">
                <span className="label-icon">📝</span>
                <span>Check Details *</span>
              </Form.Label>
              <div className="form-input-wrapper">
                <Form.Control
                  as="textarea"
                  rows={5}
                  name="description"
                  value={formData.description}
                  onChange={handleInputChange}
                  placeholder="Describe the checks performed, verification results, and any findings..."
                  required
                />
              </div>
              <Form.Text className="form-text-modern">
                <span>ℹ️</span>
                <span>Include all verification steps and results</span>
              </Form.Text>
            </Form.Group>

            <Form.Group className="form-group-modern">
              <Form.Label className="form-label-modern">
                <span className="label-icon">📅</span>
                <span>Check Date *</span>
              </Form.Label>
              <div className="form-input-wrapper">
                <Form.Control
                  type="date"
                  name="date"
                  value={formData.date}
                  onChange={handleInputChange}
                  required
                />
              </div>
            </Form.Group>

            <Form.Group className="form-group-modern">
              <Form.Label className="form-label-modern">
                <span className="label-icon">🔄</span>
                <span>Status</span>
              </Form.Label>
              <div className="form-input-wrapper">
                <Form.Select
                  name="status"
                  value={formData.status}
                  onChange={handleInputChange}
                >
                  <option value="pending">⏳ Pending</option>
                  <option value="in-progress">🔄 In Progress</option>
                  <option value="completed">✅ Completed</option>
                </Form.Select>
              </div>
            </Form.Group>

            <Form.Group className="form-group-modern">
              <Form.Label className="form-label-modern">
                <span className="label-icon">📎</span>
                <span>Attachment</span>
              </Form.Label>
              <div className="file-input-wrapper">
                <Form.Control
                  type="file"
                  id="attachment"
                  onChange={handleFileChange}
                />
              </div>
              <Form.Text className="form-text-modern">
                <span>📄</span>
                <span>Optional: Upload supporting documents (Max 10MB)</span>
              </Form.Text>
            </Form.Group>

            <div className="submit-btn-wrapper">
              <Button className="submit-report-btn" type="submit">
                <span>📤</span>
                <span>Submit Check Report</span>
              </Button>
              <Button
                className="reset-btn"
                type="button"
                onClick={() => {
                  setFormData({
                    title: '',
                    description: '',
                    date: '',
                    status: 'pending',
                  });
                  setAttachment(null);
                  document.getElementById('attachment').value = '';
                }}
              >
                🔄 Reset Form
              </Button>
            </div>
          </Form>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default CheckReport;
